import * as Yup from 'yup';

export const editProfileSchema = Yup.object().shape({
  name: Yup.string().required('Name field can not be left blank'),
});
